import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Achievements from "./components/Achievements";
import Experience from "./components/Experience";
import CaseStudies from "./components/CaseStudies";
import Clients from "./components/Clients";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Achievements />
        <Experience />
        <CaseStudies />
        <Clients />
        <Skills />
        <Education />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
